module.exports = __webpack_public_path__ + "img/hp-v2.ea1e94de.svg";